/**
 * Header JavaScript for A*Vault Theme
 * Handles mobile menu interactions and cart updates
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Header script loaded');
  
  // Get elements
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  
  console.log('Mobile menu toggle found:', !!mobileMenuToggle);

  // Mobile menu toggle functionality
  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Mobile menu toggle clicked');
      
      // Check if menu is already open
      const existingOverlay = document.getElementById('mobile-menu-overlay');
      if (existingOverlay) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
  }

  // Functions to open and close mobile menu
  function openMobileMenu() {
    console.log('Opening mobile menu');
    
    // Get navigation settings from the header section
    const headerSection = document.querySelector('[data-section-type="header"]');
    const baseUrl = window.location.origin;
    
    // Create the overlay HTML with dynamic navigation
    const overlayHTML = `
      <div id="mobile-menu-overlay" style="
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100vw !important;
        height: 100vh !important;
        z-index: 99999 !important;
        background: rgba(0, 0, 0, 0.5) !important;
        backdrop-filter: blur(4px) !important;
        opacity: 0;
        transition: opacity 0.3s ease;
      ">
        <div style="
          position: absolute !important;
          top: 0 !important;
          right: 0 !important;
          width: 320px !important;
          max-width: 85vw !important;
          height: 100vh !important;
          background: white !important;
          box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15) !important;
          transform: translateX(100%);
          transition: transform 0.3s ease;
          overflow-y: auto !important;
        " id="mobile-menu-panel">
          
          <!-- Mobile Menu Header -->
          <div style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 1rem;
            border-bottom: 1px solid #e5e7eb;
            background: white;
            position: sticky;
            top: 0;
            z-index: 10;
          ">
            <span style="
              font-size: 1.125rem;
              font-weight: 700;
              color: #111827;
            ">Menu</span>
            <button id="mobile-menu-close" style="
              padding: 0.5rem;
              color: #374151;
              background: none;
              border: none;
              cursor: pointer;
              border-radius: 0.375rem;
              transition: all 0.3s ease;
            " aria-label="Close mobile menu">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 6 6 18"></path>
                <path d="M6 6l12 12"></path>
              </svg>
            </button>
          </div>

          <!-- Mobile Menu Content -->
          <nav style="padding: 1rem;" role="navigation" aria-label="Mobile navigation">
            <ul style="list-style: none; margin: 0; padding: 0;">
              <li style="margin-bottom: 0.5rem;">
                <a href="${baseUrl}" style="
                  display: flex;
                  align-items: center;
                  padding: 0.75rem 1rem;
                  color: #374151;
                  font-weight: 500;
                  text-decoration: none;
                  border-radius: 0.5rem;
                  transition: all 0.3s ease;
                  background: transparent;
                " class="mobile-nav-link">Home</a>
              </li>
              <li style="margin-bottom: 0.5rem;">
                <a href="${baseUrl}/collections/all" style="
                  display: flex;
                  align-items: center;
                  padding: 0.75rem 1rem;
                  color: #374151;
                  font-weight: 500;
                  text-decoration: none;
                  border-radius: 0.5rem;
                  transition: all 0.3s ease;
                  background: transparent;
                " class="mobile-nav-link">Shop Decks</a>
              </li>
              <li style="margin-bottom: 0.5rem;">
                <a href="${baseUrl}/pages/about" style="
                  display: flex;
                  align-items: center;
                  padding: 0.75rem 1rem;
                  color: #374151;
                  font-weight: 500;
                  text-decoration: none;
                  border-radius: 0.5rem;
                  transition: all 0.3s ease;
                  background: transparent;
                " class="mobile-nav-link">About</a>
              </li>
              <li style="margin-bottom: 0.5rem;">
                <a href="${baseUrl}/pages/faq" style="
                  display: flex;
                  align-items: center;
                  padding: 0.75rem 1rem;
                  color: #374151;
                  font-weight: 500;
                  text-decoration: none;
                  border-radius: 0.5rem;
                  transition: all 0.3s ease;
                  background: transparent;
                " class="mobile-nav-link">FAQ</a>
              </li>
              <li style="margin-bottom: 0.5rem;">
                <a href="${baseUrl}/pages/contact" style="
                  display: flex;
                  align-items: center;
                  padding: 0.75rem 1rem;
                  color: #374151;
                  font-weight: 500;
                  text-decoration: none;
                  border-radius: 0.5rem;
                  transition: all 0.3s ease;
                  background: transparent;
                " class="mobile-nav-link">Contact</a>
              </li>
            </ul>

            <!-- Mobile Menu Footer -->
            <div style="
              margin-top: 2rem;
              padding-top: 1rem;
              border-top: 1px solid #e5e7eb;
            ">
              <a href="${baseUrl}/account" style="
                display: flex;
                align-items: center;
                padding: 0.75rem 1rem;
                color: #374151;
                font-weight: 500;
                text-decoration: none;
                border-radius: 0.5rem;
                transition: all 0.3s ease;
                background: transparent;
              " class="mobile-nav-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right: 0.75rem;">
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                My Account
              </a>
            </div>
          </nav>
        </div>
      </div>
    `;
    
    // Insert the overlay at the end of body
    document.body.insertAdjacentHTML('beforeend', overlayHTML);
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    
    // Add event listeners to the newly created elements
    const mobileMenuClose = document.getElementById('mobile-menu-close');
    const mobileMenuPanel = document.getElementById('mobile-menu-panel');
    
    if (mobileMenuClose) {
      mobileMenuClose.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Closing mobile menu via close button');
        closeMobileMenu();
      });
    }
    
    // Close menu when clicking backdrop (but not the panel)
    if (mobileMenuOverlay) {
      mobileMenuOverlay.addEventListener('click', function(e) {
        if (e.target === mobileMenuOverlay) {
          console.log('Closing mobile menu via backdrop');
          closeMobileMenu();
        }
      });
    }
    
    // Add hover effects to navigation links
    const mobileNavLinks = document.querySelectorAll('.mobile-nav-link');
    mobileNavLinks.forEach(link => {
      link.addEventListener('mouseenter', function() {
        this.style.color = '#d97706';
        this.style.background = '#f9fafb';
        this.style.transform = 'translateX(4px)';
      });
      
      link.addEventListener('mouseleave', function() {
        this.style.color = '#374151';
        this.style.background = 'transparent';
        this.style.transform = 'translateX(0)';
      });
      
      link.addEventListener('click', function() {
        console.log('Navigation link clicked, closing mobile menu');
        closeMobileMenu();
      });
    });
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
    
    // Show overlay with animation
    if (mobileMenuOverlay) {
      const panel = document.getElementById('mobile-menu-panel');
      
      // First show the overlay
      requestAnimationFrame(() => {
        mobileMenuOverlay.style.opacity = '1';
        
        // Then slide in the panel
        requestAnimationFrame(() => {
          if (panel) {
            panel.style.transform = 'translateX(0)';
          }
        });
      });
    }
    
    // Update toggle button state
    if (mobileMenuToggle) {
      mobileMenuToggle.setAttribute('aria-expanded', 'true');
    }

    // Focus management
    setTimeout(() => {
      const closeButton = document.getElementById('mobile-menu-close');
      if (closeButton) {
        closeButton.focus();
      }
    }, 100);
  }

  function closeMobileMenu() {
    console.log('Closing mobile menu');
    
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    const panel = document.getElementById('mobile-menu-panel');
    
    if (mobileMenuOverlay && panel) {
      // Slide out panel
      panel.style.transform = 'translateX(100%)';
      
      // Hide overlay after animation
      setTimeout(() => {
        mobileMenuOverlay.style.opacity = '0';
        
        // Remove from DOM after fade out
        setTimeout(() => {
          if (mobileMenuOverlay && mobileMenuOverlay.parentNode) {
            mobileMenuOverlay.remove();
          }
        }, 300);
      }, 300);
    }
    
    // Restore body scroll
    document.body.style.overflow = '';
    
    // Update toggle button state
    if (mobileMenuToggle) {
      mobileMenuToggle.setAttribute('aria-expanded', 'false');
      // Return focus to toggle button
      mobileMenuToggle.focus();
    }
  }

  // Close menu on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
      if (mobileMenuOverlay && mobileMenuOverlay.style.opacity === '1') {
        console.log('Closing mobile menu via escape key');
        closeMobileMenu();
      }
    }
  });

  // Handle window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 768) {
      const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
      if (mobileMenuOverlay && mobileMenuOverlay.style.opacity === '1') {
        console.log('Closing mobile menu due to window resize');
        closeMobileMenu();
      }
    }
  });

  // Cart update functionality
  updateCartCount();
  
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
        cartCount.setAttribute('data-cart-count', cart.item_count);
        
        // Add animation for cart updates
        cartCount.classList.add('animate-bounce');
        setTimeout(() => {
          cartCount.classList.remove('animate-bounce');
        }, 1000);
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  // Listen for cart updates
  document.addEventListener('cart:updated', updateCartCount);
  
  // Listen for Shopify cart updates
  if (window.Shopify && window.Shopify.onCartUpdate) {
    window.Shopify.onCartUpdate = updateCartCount;
  }

  // Handle cart additions
  document.addEventListener('click', function(e) {
    if (e.target.matches('[data-add-to-cart]') || e.target.closest('[data-add-to-cart]')) {
      // Trigger cart update after a short delay to allow for cart API call
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }, 500);
    }
  });
});